// extracted by mini-css-extract-plugin
export default {"container":"ComboboxCoso_container__JV+Zx","school":"ComboboxCoso_school__n-ZhW","logo":"ComboboxCoso_logo__gglpY","name":"ComboboxCoso_name__iNKIW"};